import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { FormValues } from '../hooks/useFormInitialisation';
import { useTranslations } from 'next-intl';

type Props = {
  placeholder?: string;
};

const DescriptionField = ({ placeholder }: Props) => {
  const t = useTranslations();
  const { control } = useFormContext<FormValues>();

  return (
    <div className={styles.description.container}>
      <Controller
        control={control}
        name="description"
        render={({ field: { onChange, value, onBlur } }) => (
          <input
            id={'description'}
            autoComplete="off"
            value={value ?? ''}
            onChange={onChange}
            onBlur={onBlur}
            className={styles.description.input}
            placeholder={placeholder ?? t('memoComposer.description')}
          />
        )}
        rules={{
          required: {
            value: true,
            message: t('memoComposer.descriptionRequired'),
          },
        }}
      />
    </div>
  );
};

export default DescriptionField;

const styles = {
  description: {
    container: 'border-none outline-hidden',
    input: classNames(
      'w-full bg-transparent font-normal text-sm text-ink-primary border-none outline-hidden focus:outline-hidden',
      'focus:border-transparent focus:ring-0 caret-blue-600',
      'p-0 pb-4',
    ),
  },
};
